import mixpanel from 'mixpanel-browser';

class Analytics {
  page(name, options) {
    mixpanel.track('Viewed ' + name + ' Page', options);
  }

  track(name, options) {
    mixpanel.track(name, options);
  }

  trackLink(element, name, options) {
    mixpanel.track_links(element, name, options);
  }

  initialize(config) {
    mixpanel.init(config.Mixpanel.token, config.Mixpanel);
  }

  getAnalyticsDistinctId() {
    return mixpanel.get_distinct_id();
  }
}

const analytics = new Analytics();

analytics.initialize({
  'Mixpanel': {
    token: process.env.MIXPANEL_TOKEN,
    people: true,
    crossSubdomainCookie: true
  }
});
analytics.track("main.starting");

export const trackPage = (location) => {
  analytics.page(location.pathname, {
    search: location.search,
    hash: location.hash
  });
};

export default analytics;
